import React, { Component, Fragment } from "react";
import axios from "axios";
import LoadingScreen from "react-loading-screen";
import Swal from "sweetalert2";
import { Modal, Dropdown, Table } from "react-bootstrap";
import loader from "../../Resources/Images/loader/spinner-1.gif";

class SalaryAdvance extends Component {
  state = {
    token: null,
    loading: false,
    loans: null,
    isOpen: false,
    payments:null,
    isOpenAddPayment:false,
    isOpenPayments:false,
    loanid:null
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ 
    isOpen: false,
    isOpenAddPayment:false,
    isOpenPayments:false
   });

  openModalAddPayment = (id) =>
  this.setState({
    isOpenAddPayment: true,
    loanid: id,
  });

  openModalPayments = (id) => {
    if (this.state.token) {
      var config = {
        method: "get",
        url: process.env.REACT_APP_BASE_URL + "/loanpayment/all/" + id,
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      };

      axios(config).then((res) => {
        if (res.data.success) {
          if (res.data.loanpayments[0]) {
            this.setState({
              loading: false,
              payments: res.data.loanpayments,
              isOpenPayments: true,
            });
          } else {
            this.setState({
              loading: false,
            });

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "No payments!",
            });
          }
        } else {
          this.setState({
            loading: false,
          });

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Failed to Load Payments!",
          });
        }
      });
    }
  };

  getLoans = async () => {
    this.setState({
      loading: false,
    });
    if (this.state.token) {
      var config = {
        method: "get",
        url: process.env.REACT_APP_BASE_URL + "/loan/all",
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      };

      await axios(config)
        .then((res) => {
          if (res.data.success) {
            if (res.data.loans[0]) {
              this.setState({
                loading: false,
                loans: res.data.loans,
              });
            } else {
              this.setState({
                loading: false,
              });

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "No loans found!",
              });
            }
          } else {
            this.setState({
              loading: false,
            });

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Failed to Load loans!",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  deletePayment = (id) => {
    Swal.fire({
      title: "Do you want to delete this payment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          loading: true,
        });
        if (this.state.token) {
          var config = {
            method: "delete",
            url: process.env.REACT_APP_BASE_URL + "/loanpayment/delete/" + id,
            headers: {
              Authorization: `Bearer ${this.state.token}`,
            },
          };

          axios(config)
            .then((response) => {
              if (response.data.success) {
                this.setState({
                  loading: false,
                });
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Deleted",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.closeModal();
               this.getLoans();
              }
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Error!",
              });
            });
        }
      }
    });
  };

  getPayments = async () => {
    this.setState({
      loading: false,
    });
    if (this.state.token) {
      var config = {
        method: "get",
        url: process.env.REACT_APP_BASE_URL + "/loan/all",
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      };

      await axios(config)
        .then((res) => {
          if (res.data.success) {
            if (res.data.loans[0]) {
              this.setState({
                loading: false,
                loans: res.data.loans,
              });
            } else {
              this.setState({
                loading: false,
              });

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "No loans found!",
              });
            }
          } else {
            this.setState({
              loading: false,
            });

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Failed to Load loans!",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  addaloan = async (e) => {
    e.preventDefault();
    this.setState({
      loading: true,
    });

    if (this.state.token) {
      var data = new FormData();

      data.append("empid", e.target.empid.value);
      data.append("amount", e.target.amount.value);
      data.append("remarks", e.target.remarks.value);
      data.append("installmentamount", e.target.installmentamount.value);
      data.append("closingdate", e.target.closingdate.value);
      data.append("startdate", e.target.startdate.value);


      var config = {
        method: "post",
        url: process.env.REACT_APP_BASE_URL + "/loan",
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
        data: data,
      };

      await axios(config)
        .then((response) => {
          if (response.data.success === true) {
            this.setState({
              loading: false,
              isOpen: false,
            });
            document.getElementById("loanform").reset();
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Salary Advance Added",
              showConfirmButton: false,
              timer: 1500,
            });
            this.getLoans();
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          Swal.fire("Oops...", "Error occured", "error");
        });
    }
  };

  deleteLoan = (id) => {
    Swal.fire({
      title: "Do you want to delete this loan?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          loading: true,
        });
        if (this.state.token) {
          var config = {
            method: "delete",
            url: process.env.REACT_APP_BASE_URL + "/loan/delete/" + id,
            headers: {
              Authorization: `Bearer ${this.state.token}`,
            },
          };

          axios(config)
            .then((response) => {
              if (response.data.success) {
                this.setState({
                  loading: false,
                  loans: null
                });
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Loan Deleted",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getLoans();
              }
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Error!",
              });
            });
        }
      }
    });
  };

  addPayment = async (e) => {
    e.preventDefault();
    this.setState({
      loading: true,
    });

    if (this.state.token) {
      var data = new FormData();

      data.append("loanid", this.state.loanid);
      data.append("remarks", e.target.remarks.value);
      data.append("amount", e.target.amount.value);
     

      var config = {
        method: "post",
        url: process.env.REACT_APP_BASE_URL + "/loanpayment",
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
        data: data,
      };

      await axios(config)
        .then((response) => {
          if (response.data.success === true) {
            this.setState({
              loading: false,
              isOpenAddPayment: false,
              loanid: null,
            });
            document.getElementById("paymentform").reset();
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Payment Added",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            invoiceid: null,
          });
          Swal.fire("Oops...", "Error occured", "error");
        });
    }
  };


  getEmpIds = () => {
    this.setState({
      show: { value: null, tf: false },
      loading: true,
    });

    if (this.state.token) {
      var config = {
        method: "get",
        url: process.env.REACT_APP_BASE_URL + "/employee/all",
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      };

      axios(config)
        .then((response) => {
          if (response.data.success) {
            if (response.data.employees[0]) {
              this.setState({
                empData: response.data.employees,
                loading: false,
              });
            } else {
              this.setState({
                status: "empty",
                show: { value: "No Employee Data!", tf: true },
                loading: false,
              });
            }
          } else {
            this.setState({
              loading: false,
              status: "type-failed",
              show: { value: "Failed Loading Employees!", tf: true },
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            status: "type-failed",
            show: { value: "Failed Loading Employees!", tf: true },
          });
        });
    } else {
      this.setState({
        loading: false,
        status: "auth-failed",
        show: { value: "Authentication Error!", tf: true },
      });
    }
  };

  componentDidMount() {
    this.state.token = JSON.parse(sessionStorage.getItem("userToken"));
    this.getLoans();
    this.getEmpIds();
  }

  render() {
    var ids = this.state.loans ? (
      this.state.loans.map((data, i) => {
        return (
          <tr>
            <td> {data.name}</td>
            <td> {data.startdate}</td>

            <td> {data.closingdate}</td>
            <td> {data.amount}</td>
            <td> {data.installmentamount}</td>
          <td>
          <Dropdown>
                  <Dropdown.Toggle
                    variant="primary"
                    id="dropdown-basic"
                  >
                    Quick Actions
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => this.openModalAddPayment(data.id)}
                    >
                      Add a Payment
                    </Dropdown.Item>
                    <Dropdown.Divider />

                    <Dropdown.Item
                      onClick={() => this.openModalPayments(data.id)}
                    >
                      View Payments
                    </Dropdown.Item>
                    <Dropdown.Divider />

                    <Dropdown.Item
                      onClick={() => this.deleteLoan(data.id)}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
          </td>
       
          </tr>
        );
      })
    ) : (
      <tr>No Data</tr>
    );
    var empids = this.state.empData ? (
      this.state.empData.map((data, i) => {
        return (
          <option value={data.id} key={i}>
            {data.name}
          </option>
        );
      })
    ) : (
      <option>No Data</option>
    );

    var payments = this.state.payments ? (
      this.state.payments.map((data, i) => {
        return (
          <tr>
            <td> {data.created_at}</td>

            <td> {data.amount}</td>
            <td> {data.remarks}</td>
            <td> {data.fullname}</td>
            <td>
              {" "}
              <span class="badge badge-info">{data.name}</span>
            </td>
            <td> <button onClick={()=>this.deletePayment(data.id)} class="btn btn-danger">
              Delete
              </button></td>
          </tr>
        );
      })
    ) : (
      <tr>No Data</tr>
    );
    return (
      <LoadingScreen
        loading={this.state.loading}
        bgColor="#ffffffcc"
        logoSrc={loader}
      >
        <div class="pd-20 card p-4 mb-4">
          <div class="clearfix">
            <div class="pull-left d-flex w-100">
              <h1 class="text-center text-blue h2">Loans</h1>
              <button
                type="button"
                class="ml-auto btn btn-warning"
                onClick={this.openModal}
              >
                Add a Loan
              </button>
            </div>
          </div>
        </div>
        <div class="card">
        <div class="">
          <table class="table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Start Date</th>
                <th>Closing Date</th>
                <th>Amount</th>
                <th>Installment Amount</th>
                <th></th>
             
              </tr>
            </thead>
            <tbody>{ids ? ids : <tr value="">No Data</tr>}</tbody>
          </table>
        </div>
        </div>

        <Modal size="lg" show={this.state.isOpen} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Add a Loan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form
              onSubmit={(e) => this.addaloan(e)}
              id="loanform"
            >
              <div className="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">
                  Employee * :
                </label>
                <div class="col-sm-12 col-md-10">
                  <select className="form-control" id="empid" name="empid" required>
                    <option value="">Select</option>
                    {empids ? empids : <option value="">No Data</option>}
                  </select>
                </div>
              </div>
    
              <div class="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">Given Date *:</label>
                <div class="col-sm-12 col-md-10">
                <input
                    class="form-control"
                    type="date" 
                    name="startdate"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">Closing Date *:</label>
                <div class="col-sm-12 col-md-10">
                <input
                    class="form-control"
                    type="date" 
                    name="closingdate"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">Loan Amount * :</label>
                <div class="col-sm-12 col-md-10">
                  <input
                    class="form-control"
                    type="number"
                    placeholder="Loan Amount"
                    name="amount"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">Installment Amount * :</label>
                <div class="col-sm-12 col-md-10">
                  <input
                    class="form-control"
                    type="number"
                    placeholder="Installment Amount"
                    name="installmentamount"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">Remarks:</label>
                <div class="col-sm-12 col-md-10">
                  <textarea class="form-control" name="remarks"></textarea>
                </div>
              </div>

              <div class="text-center">
                <button class="btn btn-info">Save</button>{" "}
                <button onClick={this.closeModal} class="btn btn-danger">
                  Close
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Modal size="lg" show={this.state.isOpenPayments} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Payments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Added Date</th>
                  <th>Amount</th>
                  <th>Remarks</th>
                  <th>Added By</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>{payments ? payments : <tr value="">No Data</tr>}</tbody>
            </Table>
          </Modal.Body>
        </Modal>


        <Modal
          size="lg"
          show={this.state.isOpenAddPayment}
          onHide={this.closeModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add a Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={(e) => this.addPayment(e)} id="paymentform">
              <div class="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">
                  Amount *:
                </label>
                <div class="col-sm-12 col-md-10">
                  <input
                    class="form-control"
                    type="number"
                    placeholder="Amount"
                    name="amount"
                    required
                  />
                </div>
              </div>
      
              <div class="form-group row">
                <label class="col-sm-12 col-md-2 col-form-label">
                  Payment Remarks:
                </label>
                <div class="col-sm-12 col-md-10">
                  <textarea
                    name="remarks"
                    class="form-control"
                    placeholder="Cheque Number/Trasaction Number Etc"
                  ></textarea>
                </div>
              </div>
              <div class="form-group row">
                <input
                  type="submit"
                  class="btn btn-block btn-warning"
                  value="Submit"
                />
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </LoadingScreen>
    );
  }
}

export default SalaryAdvance;
